<template>
  <div
    v-show="show"
    ref="cont"
    class="glo-tooltip glotltip anim-fade-in"
    style="position: fixed; z-index: 99"
    :style="glt ? glt.style || '' : ''"
  >
    <div
      v-if="glt"
      class="glotltip_content"
      v-html="glt.textPlain || $t(glt.text)"
    ></div>
    <div
      class="gw_btn-v1 ml-auto mt-2 gw_btn_text"
      @click="close"
    >
      {{ $t('btn.close') }}
    </div>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'GlobalTooltip',
  mixins: [float_mix],
  data() {
    return {
      l_glt: null,
    }
  },
  methods: {
    close() {
      if (this.l_glt.once) {
        const glts = JSON.parse(localStorage.getItem('glts') || '{}')
        glts[this.l_glt.id || this.l_glt.refId] = 'closed'
        localStorage.setItem('glts', JSON.stringify(glts))
      }
      this.$store.commit('globals_set', { key: 'gl_tooltip', value: null })
    },
  },
  computed: {
    glt() {
      return this.$store.getters.gl_tooltip
    },
    show() {
      return this.l_glt ? this.l_glt.routeName === this.$route.name : false
    },
  },

  watch: {
    glt(glt) {
      const referenceEl = document.getElementById(glt?.refId || this.l_glt?.refId || '')
      this.l_glt = glt
      // console.log('glt---', glt, referenceEl)
      if (!glt) {
        if (referenceEl) {
          referenceEl.removeEventListener('click', this.close)
        }
        const hBox = document.getElementById('gw_highlight-box')
        if (hBox) {
          hBox.remove()
        }
        return
      }

      const { cont } = this.$refs
      debugger
      if (referenceEl && cont) {
        const hBox = document.createElement('div')
        hBox.setAttribute('id', 'gw_highlight-box')
        hBox.setAttribute('class', 'anim-fade-in')

        referenceEl.addEventListener('click', this.close)
        referenceEl.appendChild(hBox)

        const options = { placement: 'bottom-start' }
        this.fl_setPositionStyle({ referenceEl, element: cont, options })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.glotltip {
  --clr-back: var(--clr-blue);
  --max-width: 22rem;
  --padding: 1rem;
  max-width: var(--max-width);
  background: var(--clr-back);
  padding: var(--padding);
  flex-direction: column;
  display: flex;
  border-radius: 4px;
}
</style>
